const paths = {
  home: "/",
  registration: "/register",
  login: "/login",
  contacts: "/contacts",
};

export default paths;
